import { Action } from 'redux';
import { EditFlow } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';

export interface EditFlowReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function editFlow(flow: IContentInfo): EditFlowReduxAction {
  return {
    type: EditFlow,
    flow
  };
}
